export default __webpack_public_path__ + "static/media/india_onshore_wind.099a966f.png";